import * as React from "react";
import { Label as AriaLabel, type LabelProps as AriaLabelProps } from "react-aria-components";

import { cn } from "./utils";

export interface LabelProps extends Omit<AriaLabelProps, "className"> {
  className?: string;
}

function Label({ className, ...props }: LabelProps) {
  return (
    <AriaLabel
      data-slot="label"
      className={cn(
        "flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        className,
      )}
      {...props}
    />
  );
}

export { Label };
